var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTunnel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.884,
    height: 22.241,
    viewBox: "0 0 19.884 22.241",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "funnel",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6425",
    "data-name": "Group 6425",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3822",
    "data-name": "Path 3822",
    d: "M39.083,0H20.4a.624.624,0,0,0-.6.625V4.447a.223.223,0,0,0,.006.06c0,.006.006.018.006.024s.006.018.006.03.006.018.006.03.006.018.006.024.006.024.012.03.006.012.006.024.006.018.012.03.006.012.012.024.012.018.012.024.006.018.012.024.012.018.018.024.012.018.018.024a.082.082,0,0,1,.018.024c.006.006.012.006.012.012l6.8,7.418v9.376a.6.6,0,0,0,.339.542.589.589,0,0,0,.25.054.577.577,0,0,0,.387-.143l4.775-4.066a.576.576,0,0,0,.2-.452v-5.31l6.8-7.423.012-.012a404.025,404.025,0,0,0,.036-.048.082.082,0,0,1,.018-.024.045.045,0,0,0,.012-.024c.006-.006.012-.018.018-.024s.006-.012.012-.024.012-.018.012-.03.006-.012.006-.024.006-.018.012-.03.006-.018.006-.024.006-.018.006-.03.006-.018.006-.03.006-.018.006-.024.006-.036.006-.06V.619A.619.619,0,0,0,39.083,0ZM31.689,11.644a.569.569,0,0,0-.161.393V17.3l-3.572,3.054V12.037a.569.569,0,0,0-.161-.393L21.753,5.06H37.731Zm6.8-7.775h-17.5V1.191h17.5Z",
    transform: "translate(-19.8)",
    fill: "#103bb5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTunnel);
export default __webpack_public_path__ + "static/media/tunnel.fa13b14bdd7d33ec072aa62a9b4fbfb1.svg";
export { ForwardRef as ReactComponent };